import { css } from 'emotion';

const container = css`
  flex-grow: 1;
  position: relative;
`;

export const ScreenDiscoDashboardStyles = { container };
